import { useCallback, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useCart } from '@kidslabs/module-quote';
import { checkoutStoreAPI } from '@kidslabs/module-checkout';
import { useMarketingApplyVoucherFromAllocationMutation } from '../../../types/marketing.graphql';

export const useApplyVoucher = () => {
    const { cartId } = useCart();
    const { t } = useTranslation('flash-sale');
    const [errorMessage, setErrorMessage] = useState<string | undefined>();

    const [applyVoucherMutation, { loading: applyLoading }] = useMarketingApplyVoucherFromAllocationMutation();

    const applyVoucher = useCallback(
        async (allocationId: string) => {
            const result = await applyVoucherMutation({
                variables: { allocation_id: allocationId, cart_id: cartId },
            });

            const response = result?.data?.marketingApplyVoucherFromAllocation;
            if (!response?.success) {
                const message =
                    response?.error_message ||
                    t('text_voucher_apply_failed', { defaultValue: 'Không thể áp dụng voucher' });
                setErrorMessage(message);
                throw new Error(message);
            }

            // Signal hooks watching discountVersion to refetch their data
            checkoutStoreAPI.actions.incrementDiscountVersion();
        },
        [applyVoucherMutation, cartId, t]
    );

    return {
        applyVoucher,
        applyLoading,
        errorMessage,
        setErrorMessage,
    };
};
